/** @format */

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import LabelInput from "../../../shared/components/labelInput";
import { assetUrl } from "fusion-core";
import { Helmet } from "fusion-plugin-react-helmet-async";
import AddressLookup from "../../../shared/components/addressLookup";
import Tq2Mapper from "../mappers/tq2Mapper";
import FormNavigationButtons from "../../../shared/components/FormNavigationButtons";
import QuoteStep from "../enums/QuoteStep";
import QuoteFormWrapper from "../../../shared/components/quoteFormWrapper";
import { handleNext } from "../../../shared/utils/navigationUtils";
import { fetchRating } from "../../../shared/services/simpleListItemsService";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { HotjarEventNames } from "../../../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../../../shared/utils/trackHotjarEvent";
const phoneStyle = assetUrl(
  "../../../../node_modules/react-phone-input-2/lib/style.css"
);

const Tq2 = () => {
  // Form Setup
  const {
    register,
    formState: { errors, isValid },
    watch,
    control,
    setValue,
    trigger,
    handleSubmit,
  } = useForm({
    defaultValues: Tq2Mapper.get(),
  });

  const STATE = useAppStateStore();

  // State
  const [addressData, setAddressData] = useState(null);
  const [rating, setRating] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addressError, setAddressError] = useState("");

  const validatePhoneNumber = (value) => {
    let cleanedValue = value.replace(/\D/g, "");

    if (cleanedValue.startsWith("0") && cleanedValue.length === 11) {
      return true;
    }

    if (!cleanedValue.startsWith("0")) {
      return "Phone number must start with zero.";
    }

    if (cleanedValue.length !== 11) {
      return "Phone number must be 11 digits long.";
    }

    return true;
  };

  const convertArrayFormat = (array) => {
    if (!Array.isArray(array)) {
      return [];
    }
    return array.map((item) => ({
      value: item.listItemId,
      label: item.listItemDescription,
    }));
  };

  const handleKeyDown = (event) => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
    }
  };

  // Effects
  useEffect(() => {
    const fetchAndSetRating = async () => {
      try {
        setIsLoading(true);
        const ratings = await fetchRating();
        setRating(ratings);
      } catch (error) {
        console.error("Error updating ratings:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAndSetRating();
  }, []);

  useEffect(() => {
    if (addressData) {
      setValue("addressData", addressData);
    }
  }, [addressData, setValue]);

  // Only enable next if lookUpAddress is not null
  const lookUpAddress = watch("lookUpAddress");
  const isAddressSelected =
    lookUpAddress !== null && lookUpAddress !== undefined;
  // Event Handlers

  useEffect(() => {
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TQ2_ENTERED);
  }, []);

  const onSubmit = (data) => {
    if (!isAddressSelected) {
      setAddressError("Please look up and select an address.");
      return;
    }
    if (isValid) {
      TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TQ2_NEXT_CLICKED);
    }
    setAddressError("");
    Tq2Mapper.set(data);
    handleNext(QuoteStep.TQ3);
  };

  return (
    <>
      <Helmet>
        <link rel="stylesheet" href={phoneStyle} />
      </Helmet>
      <form onSubmit={handleSubmit(onSubmit)}>
        <QuoteFormWrapper>
          <h1 className="margin-bottom-10">Contact Details</h1>
          <p className="margin-bottom-30">
            Please provide your contact information.
          </p>

          <div className="fields">
            <AddressLookup
              register={register}
              watch={watch}
              setValue={setValue}
              trigger={trigger}
              errors={errors}
              STATE={STATE}
            />
            {addressError && !isAddressSelected && (
              <span className="errorField margin-bottom-15">
                {addressError}
              </span>
            )}

            <div>
              <label className="labelName">Contact number</label>
            </div>
            <div className="phoneDivStyle">
              <LabelInput
                id="phone"
                type="number"
                placeholder="09999999999"
                pattern="[0-9]*"
                register={register("phone", {
                  required: "Required",
                  validate: validatePhoneNumber,
                })}
                trigger={trigger}
                errors={errors.phone}
                watch={watch("phone")}
                className="phoneStyle"
                onKeyDown={handleKeyDown}
              />
            </div>

            <LabelInput
              id="email"
              label="Email"
              type="email"
              placeholder="example@email.com"
              register={register("email", {
                required: "Required",
                pattern: {
                  value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
                  message: "Invalid email address",
                },
              })}
              errors={errors.email}
              emailclass="emailClass"
              watch={watch("email")}
              trigger={trigger}
            />

            <LabelInput
              id="Rating"
              label="Uber Pro rating"
              type="select"
              placeholder="Select rating"
              control={control}
              options={convertArrayFormat(rating)}
              register={register("Rating", {
                required: "Required",
              })}
              errors={errors.Rating}
              watch={watch("Rating")}
              trigger={trigger}
              isLoading={isLoading}
              classTick="classTick"
            />
          </div>
        </QuoteFormWrapper>
        <FormNavigationButtons
          prevStep={QuoteStep.TQ1}
          isValid={isValid && isAddressSelected}
        />
      </form>
    </>
  );
};

export default Tq2;
